import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { ActionButtonComponent } from "@hermes/aphrodite/action-button";
import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { SeparatorComponent } from "@hermes/aphrodite/separator";
import {
    svgArrowAngle,
    svgCheck,
    svgClock,
    SvgIconComponent,
    svgInfo,
    svgOpenExternal,
    svgPhone,
    svgPinMinimalist,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";
import { GeoService } from "@hermes/map-utils";
import { ShopsService } from "@hermes/shop-utils";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { RouterServiceModule } from "@hermes/utils-generic/services/router";

import { ShopAddressComponent } from "./components/shop-address/shop-address.component";
import { ShopInfoComponent } from "./components/shop-info/shop-info.component";
import { ShopInfoDetailsComponent } from "./components/shop-info-details/shop-info-details.component";
import { ShopInfoDirectionComponent } from "./components/shop-info-direction/shop-info-direction.component";
import { ShopInfoHeaderComponent } from "./components/shop-info-header/shop-info-header.component";
import { ShopInfoTitleComponent } from "./components/shop-info-title/shop-info-title.component";
import { DistanceFormatterPipe } from "./directives/distance-formatter.pipe";

@NgModule({
    declarations: [
        ShopInfoComponent,
        ShopInfoTitleComponent,
        ShopAddressComponent,
        ShopInfoHeaderComponent,
        ShopInfoDirectionComponent,
        ShopInfoDetailsComponent,
        DistanceFormatterPipe,
    ],
    imports: [
        ActionButtonComponent,
        CallToActionComponent,
        CommonModule,
        RouterModule,
        RouterServiceModule,
        SeparatorComponent,
        SrOnlyNoSnippetDirective,
        SvgIconComponent,
    ],
    providers: [GeoService, ShopsService],
    exports: [ShopInfoComponent],
})
export class ShopModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([
            svgArrowAngle,
            svgPinMinimalist,
            svgPhone,
            svgClock,
            svgCheck,
            svgInfo,
            svgOpenExternal,
        ]);
    }
}
